import axios from 'axios';
import store from '../store';
import { logout } from './auth/authSlice';
import { showSnackbar } from './snackbarSlice';
import appConfig from '../config/appConfig';

const apiClient = axios.create({
  baseURL: `${appConfig.apiBaseUrl}/api`,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    'X-Marmin-App': 'DEVELOPER_DASHBOARD',
  },
});

const authApiClient = axios.create({
  baseURL: `${appConfig.apiBaseUrl}/auth`,
  withCredentials: true,
  headers: {
    'X-Marmin-App': 'DEVELOPER_DASHBOARD',
  },
});

const billingClient = axios.create({
  baseURL: `${appConfig.apiBaseUrl}/billing`,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    'X-Marmin-App': 'DEVELOPER_DASHBOARD',
  },
});

export async function endSession() {
  try {
    await authApiClient.post('/logout', {}, { skipSessionRedirect: true });
  } catch {
    // Clearing the cookie is best-effort when the network call fails.
  }

  store.dispatch(logout());
}

let sessionExpiryStarted = false;

function expireAuthenticatedSession() {
  if (!store.getState().auth?.isAuthenticated || sessionExpiryStarted) {
    return;
  }

  sessionExpiryStarted = true;
  store.dispatch(
    showSnackbar({
      message: 'Session expired. Please log in again.',
      severity: 'error',
    }),
  );
  endSession().finally(() => {
    window.location.href = '/login';
  });
}

apiClient.interceptors.response.use(
  (response) => {
    if (response.status === 202) {
      store.dispatch(
        showSnackbar({
          message: response.data?.message || 'Request accepted successfully',
          severity: 'success',
        }),
      );
    }
    return response;
  },
  (error) => {
    if (error.response) {
      const { status, data } = error.response;

      switch (status) {
        case 401:
          if (error.config?.skipSessionRedirect) {
            break;
          }
          expireAuthenticatedSession();
          break;
        case 400:
          break;
        case 403:
          break;
        case 404:
          break;
        default:
          store.dispatch(
            showSnackbar({
              message: error.response.data.message || 'An unexpected error occurred',
              severity: 'error',
            }),
          );
      }
    }
    return Promise.reject(error);
  },
);

export { apiClient, authApiClient, billingClient };
